import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const Report2DataSchemas = zod.object({
    traderId: zod.string().nullable(),
    traderName: zod.string().nullable(),
    traderType: zod.string().nullable(),
    transactionType: zod.string().nullable(),
    calendarUnit: zod.string().nullable(),
    transactionsCount: zod.number(),
    purchaseValueSum: zod.string(),
    loyaltyValueSum: zod.string(),
    creditValueSum: zod.string().optional(),
    voucherValueSum: zod.string(),
})

export const Report2CSVDataSchemas = zod.object({
    traderId: zod.string().nullable(),
    traderName: zod.string().nullable(),
    traderType: zod.string().nullable(),
    transactionType: zod.string().nullable(),
    calendarUnit: zod.string().nullable(),
    transactionsCount: zod.number(),
    purchaseValueSum: zod.string(),
    loyaltyValueSum: zod.string(),
    creditValueSum: zod.string().optional(),
    voucherValueSum: zod.string(),
})

export const Report2ParamsSchemas = zod.object({
})

export const Report2ListTableSchemas = zod.object({
    tableData: Report2DataSchemas.array()
})

export const Report2CreateFormSchemas = zod.object({
    includeAllTrader: zod.number(), // Mandatory: 1 if all traders are to bw shown
    fromTraderIds: zod.number().array().nullable(),
    reportTypeId: zod.string(),
    startDate: zod.string().min(1, { message: 'Start date is Required.' }),
    endDate: zod.string().min(1, { message: 'End date is Required.' }),
    calendarUnit: zod.number(),
    showSubGroupTotal: zod.number(),
    showGrandTotal: zod.number(),
    dimColumnOrder: zod.number().array().min(1, { message: 'At least one dimension column is required.' }),
})

export const Report2APISchemas = DefaultSchemas.merge(zod.object({
    data: Report2DataSchemas.array()
}));

export type Report2CreateFormTypes = zod.infer<typeof Report2CreateFormSchemas>;
export type Report2ListTableTypes = zod.infer<typeof Report2ListTableSchemas>;
export type Report2ParamsTypes = zod.infer<typeof Report2ParamsSchemas>;
export type Report2DataTypes = zod.infer<typeof Report2DataSchemas>;
export type Report2CSVDataTypes = zod.infer<typeof Report2CSVDataSchemas>;
export type Report2APITypes = zod.infer<typeof Report2APISchemas>;